import axios, { AxiosResponse } from 'axios' 
import { IExpenseDefinitionModel } from './ExpenseModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const EXPENSE_CREATE_URL = `${API_URL}api/v1/definition/expense/create`
export const EXPENSE_GET_ALL_URL = `${API_URL}api/v1/definition/expense/all`
export const EXPENSE_DELETE_URL = `${API_URL}api/v1/definition/expense/delete/`
export const EXPENSE_UPDATE_URL = `${API_URL}api/v1/definition/expense/update/`

export function createExpense(expense: IExpenseDefinitionModel) {
  return axios.post(EXPENSE_CREATE_URL, expense)
}

export async function loadExpenses(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IExpenseDefinitionModel>>>> {
  return axios.get(EXPENSE_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteExpense(expenseId: String) {
  return axios.post(EXPENSE_DELETE_URL + expenseId)
}

export function updateExpense(expense: IExpenseDefinitionModel) {
  return axios.post(EXPENSE_UPDATE_URL + expense.id, expense)
}
